import { Address_Country as Country } from "gen/proto/address/models_pb"

import { useGetCompanyQuery } from "features/api/company"

export function useCountry(): Country {
  const { data: getCompanyData } = useGetCompanyQuery({})
  return getCompanyData?.company?.country ?? Country.US
}
